module.exports = __webpack_public_path__ + "img/tebrikler-233.3019290f.png";